export default {
  mainPage: 'Página Principal',
  additionalInformationAdded: 'Informações adicionais adicionadas',
  assignOrSelectTheNameFromTheList: 'Atribua ou selecione o nome da lista',
  AddPeopleToAnExistingList: 'Adicione pessoas a uma lista existente',
  updateList: 'Lista de atualização',
  completeTheRequiredFields: 'Complete os campos necessários',
  anErrorHasOcurred: 'Um erro ocurou',
  eventModified: 'Evento modificado',
  insertKeybeUiOnYourWebsite: 'Insira Keybe UI no seu site',
  toInsertKeybeUiIntoYourWebsiteYouMustCreateADivElementWithTheIdKeybe: 'Para inserir o KeybeUI no seu site, você deve criar um elemento DIV com a identificação \'keybe\' no corpo do seu site',
  andThenAddTheFollowingScriptInTheFooterOfYourSite: 'E então adicione o seguinte Roteiro no rodapé do seu site',
  toAddElementsInTheDOMToOpenTheKeybeUIYouCanUseAScriptSimilarToTheFollowing: 'Para adicionar elementos no DOM para abrir o KeybeUI, você pode usar um script similar aos seguintes',
  selectProfilePhoto: '',
  selectPhoto: 'Selecione a foto do perfil',
  photoSuccessfullyUpdated: 'foto Atualizada com Sucesso',
  select: 'Selecione'
}
